export const DEFAULT_CONTEXT_MODE = "context_free"

/** Learner testing: UI label → generation API context_mode. */
export const CONTEXT_MODE_OPTIONS = [
  { value: "context_free", label: "Text questions" },
  { value: "auto", label: "Automatic" },
  { value: "data_table", label: "Data table" },
  { value: "chart", label: "Chart" },
  { value: "angle", label: "Angle diagram" },
  { value: "coordinate_graph", label: "Coordinate graph" },
  { value: "geometry_diagram", label: "Geometry diagram" },
  { value: "visual_reasoning", label: "AI-generated visual" },
] as const
